// File Metadata:
// Filename: NewShipmentFormHU.js
// Version: 1.00
// Created: 2022-10-21 21:08:53
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import React, { Component } from 'react'
import Scanner from '../../../components/Scanner'
import { Button, TextField, Modal, Card, CardHeader, CardContent, FormControl, ButtonGroup, Alert } from '@mui/material'
import '../../../components/Scanner.css'
import { Box } from '@mui/system'

class NewShipmentFormHU extends Component {
	state = {
		result: this.props.values.sscc || '',
		open: false,
		errMsg: ''
	}

	next = e => {
		e.preventDefault()
		if (this.state.result) {
			this.handleConfirmScan()
			this.props.nextStep()
		} else {
			this.setState({ errMsg: 'You must scan the HU to continue!' })
		}
	}

	back = e => {
		e.preventDefault()
		this.setState({ errMsg: '' })
		this.handleConfirmScan()
		this.props.prevStep()
	}

	handleToggleScanner = () => {
		this.setState({ open: !this.state.open })
		if (this.state.errMsg) this.setState({ errMsg: '' })
	}

	handleConfirmScan = () => {
		this.props.handleValue('sscc', this.state.result)
		if (this.state.errMsg) {
			this.setState({ errMsg: '' })
		}
	}

	handleChange = e => {
		this.setState({ result: e.target.value })
	}

	_onDetected = code => {
		this.setState({ result: code })
		this.handleToggleScanner()
	}

	render() {
		//const { values } = this.props
		return (
			<>
				<Card sx={{ width: 345, minWidth: 200, boxShadow: 2, margin: 2 }}>
					<CardHeader title='Step 2: Scan HU' subheader='' />
					<CardContent>
						{this.state.errMsg && <Alert severity='error'>{this.state.errMsg}</Alert>}
						<FormControl margin='normal' fullWidth variant='filled'>
							<TextField
								className='scanner__output'
								fullWidth
								size='small'
								margin='normal'
								variant='filled'
								label='scan a handling unit'
								value={this.state.result}
								onChange={this.handleChange}
							/>
						</FormControl>
						<ButtonGroup fullWidth variant='contained'>
							<Button onClick={this.back}>Back</Button>
							<Button onClick={this.handleToggleScanner}>Scan</Button>
							<Button onClick={this.next}>Next</Button>
						</ButtonGroup>
					</CardContent>
				</Card>
				<Modal open={this.state.open} onClose={this.handleToggleScanner}>
					<Box sx={style}>
						<Scanner onDetected={this._onDetected} />
						<TextField
							className='scanner__output'
							fullWidth
							size='small'
							margin='normal'
							value={this.state.result ? this.state.result : 'No data scanned'}
						/>

						{this.state.result && (
							<Button fullWidth mt={2} onClick={this.handleConfirmScan} variant='contained'>
								Confirm Scan
							</Button>
						)}
					</Box>
				</Modal>
			</>
		)
	}
}

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 350,
	bgcolor: 'background.paper',
	border: '2px dashed #555',
	boxShadow: 6,
	p: 4
}

export default NewShipmentFormHU
